import React, { useEffect, useState } from 'react'
import { useSocketService } from '../../context/SocketServiceContext'
import { default as ReactAvatar } from 'react-avatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const logo = require('../../images/xlab-logo.jpg')

import Kedo from '../../Kedo.js'

interface IAvatarOptions {
    togglePresence?: boolean
    size?: number
    showPresence?: boolean
}

interface User {
    userId: string | number
    username: string
}

interface AvatarProps {
    kedo: Kedo
    user: User
    props?: any
    onClick?: () => void
    options?: IAvatarOptions
}

const Avatar: React.FC<AvatarProps> = ({
    kedo,
    user,
    props,
    onClick,
    options = { size: 35, showPresence: true, togglePresence: false },
}) => {
    const socketService = useSocketService()
    const [status, setStatus] = useState<string>('')
    const [toggle, setToggle] = useState(false)
    const [avatar, setAvatar] = useState<string>('')

    // Initialize presence if togglePresence is enabled
    useEffect(() => {
        if (options?.togglePresence) {
            kedo.api()
                .get(kedo.api().getUserProfileEndpoint('me'))
                .then((result) => {
                    if (
                        result.data &&
                        result.data.private_settings &&
                        result.data.private_settings.presence
                    ) {
                        socketService.user
                            .setPresence(result.data.private_settings.presence)
                            .then((resultPresence: string) => {
                                setStatus(resultPresence)
                                setToggle(false)
                            })
                    }
                })
                .catch((errResponse) => console.log(errResponse))
        }
    }, [])

    // Update presence from socketService
    useEffect(() => {
        setStatus(socketService.user.getPresence(user.userId))
    }, [socketService.user.getPresence(user.userId)])

    // Map presence string to color
    const presence = (presence: string): string => {
        switch (presence) {
            case 'online':
                return 'green'
            case 'busy':
                return 'red'
            case 'away':
                return 'orange'
            default:
                return 'unset'
        }
    }

    // Fetch user avatar
    const fetchAvatar = () => {
        kedo.api()
            .getCached(kedo.api().getUserEndpoint(user.userId))
            .then((response) => {
                setAvatar(
                    response.data && response.data.avatar?.length > 0
                        ? kedo
                              .api()
                              .getUserAvatarEndpoint(
                                  user.userId,
                                  response.data.avatar
                              )
                        : ''
                )
            })
    }

    useEffect(() => {
        fetchAvatar()
    }, [user])

    return (
        <div className={'avatar-online'} onClick={onClick}>
            <ReactAvatar
                name={`${user.username}`}
                round={true}
                value="40%"
                size={options?.size || 35}
                src={avatar || (!user?.username ? logo : undefined)}
            />

            {options?.showPresence &&
                kedo.env() &&
                kedo.env().hasEnviroment() && (
                    <FontAwesomeIcon
                        style={{
                            color: presence(status),
                            top:
                                options?.size && options.size <= 26
                                    ? '16px'
                                    : '22px',
                            left:
                                options?.size && options.size <= 26
                                    ? '16px'
                                    : '22px',
                        }}
                        icon={faCircle}
                    />
                )}
        </div>
    )
}

export default Avatar
